import React from 'react';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignJustifyIcon from '@material-ui/icons/FormatAlignJustify';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

export default function ToggleButtonsPrecentSmall() {
  const [alignment, setAlignment] = React.useState('left');

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <ToggleButtonGroup
      value={alignment}
      exclusive
      onChange={handleAlignment}
      aria-label="text alignment"
    >
      

      
          <ToggleButton style={{width:"70px"}} value="left">
            100%
          </ToggleButton>
          <ToggleButton style={{width:"70px"}} value="center">
            50%
          </ToggleButton>
          <ToggleButton style={{width:"70px"}} value="right">
            25%
          </ToggleButton>
          <ToggleButton style={{width:"70px"}} value="justify">
            10%
          </ToggleButton>
          <ToggleButton style={{width:"70px"}} value="darkright">
            5%
          </ToggleButton>
        </ToggleButtonGroup>
  );
}